import styled from 'styled-components'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { ENV_CONFIG } from '@/constants/env/config'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import { LocationEnum } from '@/constants/location.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import useShareLink from '@/containers/hooks/share-link.hook'

interface ProductDetailShareLinkProps {
  name: string
  productId: number
  productPromotionId?: number
  location: LocationEnum
  discountRate?: number
  reviewAvgScore: number
  reviewAvgCount: number
  price: number
}

export const ProductDetailShareLink = ({
  name,
  productId,
  productPromotionId,
  location,
  discountRate,
  reviewAvgScore,
  reviewAvgCount,
  price,
}: ProductDetailShareLinkProps) => {
  const { processShareLink } = useShareLink()
  const tracker = useTracker()
  const shareLink = async (name: string, eventProperty: { [key: string]: string }) => {
    const url = productPromotionId
      ? `${ENV_CONFIG.fitpetmallHost}/products/${productId}?promotion=${productPromotionId}`
      : `${ENV_CONFIG.fitpetmallHost}/products/${productId}`

    processShareLink(url, {
      appBridgeData: {
        title: name,
        eventName: FitpetMallEventEnum.ClickProductdetailSharetypeButton,
        eventProperty,
      },
    })
  }
  const handleClickShareButton = () => {
    const properties = {
      productId: productId,
      productName: name,
      productPurchasePrice: price,
      productDiscountRate: discountRate,
      productReviewAvgscore: reviewAvgScore,
      productReviewTotalCount: reviewAvgCount,
      ...(location ? { location } : {}),
    }
    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickProductdetailShareButton, properties)
    shareLink(name, tracker.getEventProperties(FitpetMallEventEnum.ClickProductdetailShareButton, properties))
  }

  return (
    <ProductDetailShareLinkWrapper className="product-detail-share-link">
      <button
        type="button"
        className="product-detail-share-link__button"
        onClick={handleClickShareButton}
        aria-label="공유하기"
      >
        <FlatIcon type={IconNameEnum.IcShare} size={IconSizeEnum.Size24} />
      </button>
    </ProductDetailShareLinkWrapper>
  )
}

const ProductDetailShareLinkWrapper = styled.div`
  .product-detail-share-link {
    &__button {
      padding: 0;
      border: none;
      background-color: transparent;
      cursor: pointer;
    }
  }
`
